import * as React from "react";
import { Icon } from "../actions/Icon";

/**
 * A marked moment (flag) inside a live transcript or recording.
 */
export interface MomentProps {
  text: React.ReactNode;
  time: string;
  label?: string;
  className?: string;
}

export function Moment({ text, time, label = "Moment", className }: MomentProps): JSX.Element {
  return (
    <div className={["gk-moment", className].filter(Boolean).join(" ")}>
      <Icon name="flag" fill size={18} />
      <div className="gk-moment__body">
        <b>{label}</b> · {text}
      </div>
      <span className="gk-moment__t">{time}</span>
    </div>
  );
}
